import { Box, Flex, IconButton, List, ListItem } from "@chakra-ui/react";
import { FormInput, FormSelect, NumericFormInput } from "../../../../../components/Forms";
import { MdClose } from "react-icons/md";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { AppendToListButton } from "./index";

function InsuranceCoveragesFieldArray({ fields, register, errors, formKey, appendItem, removeItem }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierPhysicalRiskQuestionnaire"
  });

  return (<>
      {fields && fields.length > 0 &&
        <List>
          {fields.map((item, index) => {
            return (
              <ListItem key={item.id} marginBlockEnd="2">
                <Flex alignItems="flex-start" gap="2">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexShrink="0"
                    inlineSize="8"
                    blockSize="8"
                    borderWidth="thin"
                    borderRadius="full"
                    fontSize="sm"
                    fontWeight="semibold"
                    marginBlockStart="6"
                  >
                    {index + 1}
                  </Box>
                  <FormSelect
                    label={t("inputs.insuranceType")}
                    errors={errors}
                    {...register(`${formKey}.${index}.insuranceType`)}
                    defaultValue=""
                  >
                    <option value="" disabled>{t("inputs.insuranceTypePlaceholder")}</option>
                    <option value="allRisksPolicy">{t("insuranceTypeOptions.allRisksPolicy")}</option>
                    <option value="namedPerilsOnly">{t("insuranceTypeOptions.namedPerilsOnly")}</option>
                  </FormSelect>
                  <NumericFormInput
                    placeholder={t("inputs.coverageUSD")}
                    label={t("inputs.coverageUSD")}
                    errors={errors}
                    {...register(`${formKey}.${index}.coverage`)}
                  />
                  <FormInput
                    placeholder={t("inputs.insuranceCompanyPlaceholder")}
                    label={t("inputs.insuranceCompany")}
                    errors={errors}
                    {...register(`${formKey}.${index}.insuranceCompany`)}
                  />
                  <IconButton
                    type="button"
                    icon={<MdClose size="24" />}
                    flexShrink="0"
                    variant="ghost"
                    marginBlockStart="5"
                    onClick={() => removeItem(index)}
                  />
                </Flex>
              </ListItem>
            );
          })}
        </List>
      }
      <AppendToListButton
        onClick={() => {
          appendItem({
            insuranceType: "",
            coverage: "",
            insuranceCompany: ""
          });
        }}
        buttonText={t("buttons.addAnotherInsurance")}
      />
    </>
  );
}

export default InsuranceCoveragesFieldArray;